/**
 * <s-signup-popup delay="ms" [data-success]>
 * Opens its child <dialog> once per visitor after a delay. Opens right away
 * when the server marks a successful signup so the visitor sees their code.
 * Dismissal and signup are remembered in localStorage so it never nags.
 */
const STORAGE_KEY = 'venes-signup-popup';

class SSignupPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    if (this.hasAttribute('data-success')) {
      this.remember('subscribed');
      this.dialog.showModal();
      return;
    }
    if (this.recall()) return;

    const delay = Number(this.getAttribute('delay')) || 8000;
    this.timer = window.setTimeout(() => this.open(), delay);
    this.dialog.addEventListener('close', () => this.remember('dismissed'));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
  }

  open() {
    if (document.querySelector('dialog[open]')) return;
    this.dialog.showModal();
  }

  recall() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }

  remember(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* Storage can be blocked; the popup then simply shows again next visit. */
    }
  }
}

customElements.define('s-signup-popup', SSignupPopup);
